import NavBar from "../navbar";
import Footer from "../footer";
import { useState } from "react";

import { Description, Field, FieldGroup, Fieldset, Label, Legend } from '../../catalyst/fieldset'
import { Input } from '../../catalyst/input'
import { Select } from '../../catalyst/select'
import { Text } from '../../catalyst/text'
import { Textarea } from '../../catalyst/textarea'
import InputWithError from "../../catalyst/custom/inputWithError";
import { Button } from "../../catalyst/button";
import { TextLink } from "../../catalyst/text";
import Spinning from "../../components/spinning";
import { ErrorMessage } from "../../catalyst/fieldset";
import { Badge } from "../../catalyst/badge";





export default function Contact() {


    const [showThanks, setShowThanks] = useState(false)
    const [errors, setErrors] = useState({});
    const [errResponse, setErrResponse] = useState("");

    const [submitting, setSubmitting] = useState(false)


    const [result, setResult] = useState("sending");

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
        access_key: ''
    });


    const validate = (submittedFormData) => {
        let errors = {};

        if (!submittedFormData.name) {
            errors.name = "Name is requred";
        }

        if (!submittedFormData.email) {
            errors.email = "Valid email required";
        } else if (!/\S+@\S+\.\S+/.test(submittedFormData.email)) {
            errors.email = "Valid email required";
        }

        if (!submittedFormData.message) {
            errors.message = "Message is requred";
        }

        return errors;
    };


    function handleSubmission(e) {

        e.preventDefault();
        var formDataObj = new FormData(e.currentTarget);

        var newData = {
            name: formDataObj.get('name'),
            email: formDataObj.get('email'),
            message: formDataObj.get('message'),
            "access_key": "46b3d8b1-eeb8-4681-9114-feb3d40ac0b1"
        }


        setFormData(newData)
        const validationErrors = validate(newData);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            setErrors({});
            setSubmitting(true)
            fetch("https://api.web3forms.com/submit", { // Replace with your actual endpoint
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newData)
            })
                .then(response => {
                    setSubmitting(false)
                    if (!response.ok) {
                        if (response.status === 400) {
                            return response.text().then(text => {
                                throw new Error("Failed to submit form. Please write an email or retry.");
                            });
                        }
                        throw new Error("Failed to submit form. Please write an email or retry.");
                    }
                    return response.text();
                })
                .then(data => {
                    setShowThanks(true);
                    setFormData({})
                    setErrors({});
                })
                .catch((error) => {
                    setSubmitting(false)
                    setErrResponse(error.message)
                    setErrors({});
                    console.error('Error:', error);
                });
        }
    }


    function ThanksMessage() {
        return (
            <>
                <div className="flex gap-3">
                    <Badge color="lime">Thank you for contacting us, we will get back to you soon!</Badge>
                </div>
            </>
        )
    }


    return (

        <>

            {/* {Navbar} */}
            <NavBar selected={"contact"}></NavBar>

            <section className="bg-gray-50 dark:bg-zinc-800">

                <div className="max-w-screen-xl px-4 pt-20 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-50 lg:pt-28">
                    <div className="text-gray-500 sm:text-lg dark:text-gray-400">
                        {showThanks ? <><ThanksMessage /></> : <>
                            <form onSubmit={handleSubmission}>

                                <Fieldset>
                                    <h1 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">Contact us</h1>
                                    <Text>How can we help you?</Text>
                                    <FieldGroup>



                                        <InputWithError error={errors.name} type="name" name="name" label={"Name"} onChange={() => { }} />
                                        <InputWithError error={errors.email} type="email" name="email" label={"Email"} onChange={() => { }} />


                                        <Field>
                                            <Label>Message</Label>
                                            <Textarea name="message" />
                                            <Description>Please write us with detailed information.</Description>
                                            {errors.message && errors.message.length > 1 && <ErrorMessage>{errors.message}</ErrorMessage>}
                                        </Field>
                                    </FieldGroup>

                                    {errResponse && <Field><ErrorMessage>{errResponse}</ErrorMessage></Field>}


                                    <Button type="submit" className="w-full" disabled={submitting}>
                                        {submitting ? <Spinning /> : "Submit"}
                                    </Button>

                                </Fieldset>

                            </form>

                        </>}

                    </div>
                </div>
            </section>

            <section className="bg-white dark:bg-zinc-950">
                <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6 ">
                    <h2 className="mb-6 text-3xl font-extrabold tracking-tight text-center text-gray-900 lg:mb-8 lg:text-3xl dark:text-white">
                        You can also write email to us
                    </h2>

                    <div className="text-center">
                        <TextLink href="mailto:hello@musicporter.com">hello@musicporter.com</TextLink>
                    </div>
                </div>
            </section>

            <Footer></Footer>
        </>
    )
}